import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./floor-input-place-image.module.scss";
import VelavuNotice from "../../../../elements/velavu-notice/velavu-notice";
import VelavuSlider from "../../../../elements/velavu-slider";
import VelavuSelect from "../../../../elements/velavu-select";
import { classArr } from "../../../../helper/style-helper";
import ReferenceFloor, {
	referenceFloorToString,
} from "../../../../state/floor/reference-floor";

export interface FloorInputPlaceImageProps {
	className?: string;

	imageOpacity: number;
	onChangeImageOpacity: (opacity: number) => void;

	availableFloors: ReferenceFloor[];
	referenceFloorID: string | null;
	onSelectReferenceFloor?: (floorID: string | null) => void;
}

const SELECT_OPTION_NONE = "";

export default function FloorInputPlaceImage(props: FloorInputPlaceImageProps) {
	const { t } = useTranslation();
	const propsOnSelectReferenceFloor = props.onSelectReferenceFloor;

	const selectReferenceFloorValue =
		props.referenceFloorID ?? SELECT_OPTION_NONE;
	const onChangeReferenceFloorValue = useCallback(
		(value: string) => {
			if (value === SELECT_OPTION_NONE) {
				propsOnSelectReferenceFloor?.(null);
			} else {
				propsOnSelectReferenceFloor?.(value);
			}
		},
		[propsOnSelectReferenceFloor],
	);

	return (
		<div className={classArr(props.className, styles.content)}>
			<VelavuNotice type="info">
				{t("dashboard.floor_input.place_image_notice")}
			</VelavuNotice>

			<h3 className={styles.subheader}>
				{t("dashboard.floor_detail.image_opacity")}
			</h3>

			<VelavuSlider
				min={0}
				max={1}
				step={0.25}
				value={props.imageOpacity}
				onChange={props.onChangeImageOpacity}
				variant="marked"
			/>

			<h2 className={styles.header}>
				{t("dashboard.floor_input.reference_floor")}
			</h2>

			<VelavuSelect
				value={selectReferenceFloorValue}
				onChange={onChangeReferenceFloorValue}
				fullWidth
			>
				{props.availableFloors.map((floor) => (
					<option key={floor.id} value={floor.id}>
						{referenceFloorToString(floor)}
					</option>
				))}

				<option value={SELECT_OPTION_NONE}>{t("common.none")}</option>
			</VelavuSelect>
		</div>
	);
}
